module.exports = __webpack_public_path__ + "img/arvhive.45915e85.svg";